import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { localStorageItems } from 'setup/localStorage';

// declare module "react-i18next" {
//   interface UseTranslationResponse {
//     t: TFunction<string, string>;
//
//     defaultNS: "ns1";
//
//     resources: {
//       l: {
//         k: "lk";
//       };
//     };
//   }
// }

export type supportedLangs = 'uk' | 'en';

i18n.use(initReactI18next).init({
  resources: {
    en: {},
    uk: {},
  },
  lng: localStorage.getItem(localStorageItems.appLanguage) || 'uk',
  fallbackLng: 'uk',

  interpolation: {
    escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  },
});

// import i18n from 'i18next';
// import { initReactI18next, useTranslation } from 'react-i18next';
// import Backend from 'i18next-http-backend';
//
// i18n
//   .use(initReactI18next)
//   .use(Backend)
//   .init({
//     fallbackLng: 'en',
//     backend: {
//       loadPath: `${import.meta.env.BASE_URL}locales/{{lng}}/translation.json`,
//     },
//   });
